// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  isOpen: boolean;
  title: string;
  submitLabel: string;
  // True while the resolve is in flight.
  isPending: boolean;
  onSubmit: () => void;
  onClose: () => void;
  children: ReactNode;
}

/** The chrome every quarantine resolution dialog shares. */
export function QuarantineResolutionDialogShell(props: Props) {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={props.isOpen}
      onClose={props.isPending ? undefined : props.onClose}
      disableEscapeKeyDown={props.isPending}
      PaperProps={{
        component: 'form',
        onSubmit: props.onSubmit,
        sx: { overflow: 'hidden' },
      }}
    >
      <DialogTitle
        sx={{ borderBottom: '1px solid', borderColor: 'divider', pb: 2 }}
      >
        {props.title}
      </DialogTitle>

      <DialogContent sx={{ py: 3 }}>{props.children}</DialogContent>

      <DialogActions
        sx={{ px: 3, py: 2, borderTop: '1px solid', borderColor: 'divider' }}
      >
        <Button
          onClick={props.onClose}
          variant="outlined"
          disabled={props.isPending}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={props.isPending}
          sx={{ ml: 1.5 }}
        >
          {props.submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
